<template>
  <div class="codemirror-editor">
    <div class="code-area left">
      <div class="code html" :class="{ half: useJS }">
        <span class="title">HTML</span>
        <textarea :id="index + '0'" v-model="html" />
      </div>

      <div v-show="useJS" class="code js" :class="{ half: useJS }">
        <span class="title">Javascript + No-Library(pure JS)</span>
        <textarea :id="index + '1'" v-model="js"></textarea>
      </div>
    </div>

    <div class="code-area right">
      <div v-show="useJS" class="code css" :class="{ half: useJS }">
        <span class="title">CSS</span>
        <textarea :id="index + '2'" v-model="css"></textarea>
      </div>
      <iframe
        :id="`custom-template ${previewStatus}`"
        :class="`custom-template ${previewStatus}`"
      />
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  reactive,
  toRefs,
  watch,
  onActivated,
  computed,
  popScopeId,
} from "vue";

import CodeMirror from "codemirror";
import "codemirror/lib/codemirror.js";
import "codemirror/lib/codemirror.css";

import "codemirror/mode/xml/xml.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/css/css.js";
import "codemirror/theme/material.css";

export default {
  name: "CodemirrorEditor",
  props: {
    index: Number,
    currentIndex: Number,
    data: Object,
    previewStatus: String,
    onChangeCodemirror: Function,
    isPhishing: Boolean,
  },
  setup(props) {
    const state = reactive({
      html: props.data.html,
      css: props.data.css,
      js: props.data.js,
    });

    const useJS = computed(() => props.currentIndex && props.isPhishing);

    const editors = [
      {
        type: "html",
        mode: "xml",
      },
      {
        type: "js",
        mode: "javascript",
      },
      {
        type: "css",
        mode: "css",
      },
    ];

    onMounted(() => {
      editors.map((item, idx) => {
        // CodeMirror.fromTextArea(대상,옵션): textarea에 codemirror 속성 부여
        CodeMirror.fromTextArea(
          document.getElementById(props.index + "" + idx),
          {
            mode: item.mode,
            lineNumbers: true,
            theme: "material",
            tabSize: 2,
          }
        ).on("change", (editor) => {
          // onChange 이벤트
          props.onChangeCodemirror(
            item.type,
            props.currentIndex,
            editor.getValue()
          );
        });
      });
    });

    return {
      ...toRefs(state),
      useJS,
    };
  },
};
</script>
